import axiosInstance from "./axiosInstance";

// POST /api/posts/share/
export const sharePost = async (postId, platform) => {
  const response = await axiosInstance.post(`/share/`, {  // ✅ /posts/share → /share/
    post_id: postId,
    share_type: "EXTERNAL",
    platform,
  });
  return response.data;
};

export const getShareCount = async (postId) => {
  const response = await axiosInstance.get(`/share/count/${postId}/`);
  return response.data;
};
